import { ColumnDef } from '@tanstack/react-table';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import RigModal from 'components/modals/RigModal';
import { useState } from 'react';
import { RigResponse, DELETE_RIG } from 'services/api/rigs';
import { useQueryClient } from 'react-query';
import { format } from 'date-fns';
import toast from 'react-hot-toast';

const handleDelete = async (rigId: string) => {
  try {
    await DELETE_RIG(rigId);
    toast.success('Rig deleted successfully');
  } catch (error: any) {
    toast.error(error?.response?.data?.message || 'Error deleting rig');
  }
};
export const rigsColumns = (
  canEdit = false,
  canDelete = false
): ColumnDef<RigResponse>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row: { original } }) => {
      const name = original.name;
      return <div className="d-flex align-items-center">{name}</div>;
    },
    meta: {
      headerProps: { style: { width: '25%' }, className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },
  {
    accessorKey: 'description',
    header: 'Rig Type',
    cell: ({ row: { original } }) => {
      const description = original.description || 'N/A';
      return (
        <div className="d-flex align-items-center">{description || 'N/A'}</div>
      );
    },
    meta: {
      headerProps: { style: { width: '25%' }, className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },
  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row: { original } }) => {
      return (
        <div className="d-flex align-items-center">
          {format(new Date(original.createdAt), 'MMM dd, yyyy HH:mm')}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '20%' } },
      cellProps: { className: 'white-space-nowrap' }
    }
  },
  {
    accessorKey: 'updatedAt',
    header: 'Updated At',
    cell: ({ row: { original } }) => {
      return (
        <div className="d-flex align-items-center">
          {format(new Date(original.updatedAt), 'MMM dd, yyyy HH:mm')}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '20%' } },
      cellProps: { className: 'white-space-nowrap' }
    }
  },
  {
    id: 'rigDropdown',
    cell: ({ row: { original } }) => {
      const rigId = (original as any).id || original._id;
      const navigate = useNavigate();
      const queries = useQueryClient();
      const [showModal, setShowModal] = useState(false);

      const handleDeleteClick = async (rigId: string) => {
        try {
          await handleDelete(rigId);
          queries.invalidateQueries('get_rigs');
          navigate('/home/apps/rig');
        } catch (error) {
          console.error('Error handling delete:', error);
        }
      };

      if (!canEdit && !canDelete) {
        return null;
      }
      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <>
                {canEdit && (
                  <Dropdown.Item
                    eventKey="2"
                    onClick={() => setShowModal(true)}
                  >
                    Edit
                  </Dropdown.Item>
                )}
                {canDelete && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      eventKey="4"
                      className="text-danger"
                      onClick={() => handleDeleteClick(rigId)}
                    >
                      Delete
                    </Dropdown.Item>
                  </>
                )}
              </>
            </RevealDropdown>
          </RevealDropdownTrigger>

          {showModal && (
            <RigModal
              show={showModal}
              handleClose={() => setShowModal(false)}
              isEditing
              rig={original}
            />
          )}
        </>
      );
    },
    meta: {
      cellProps: {
        className: 'text-end pe-0 ps-4'
      }
    }
  }
];
